import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "react-hot-toast";
import { theme, ConfigProvider } from "antd";
import fa_IR from "antd/locale/fa_IR";
import Main from "./components/layout/Main";
import SignIn from "./pages/SignIn";
import "antd/dist/reset.css";
import { QueryClient, QueryClientProvider } from "react-query";
import ProtectedRoute from "./components/utils/ProtectedRoute";
import GeoUnit from "./pages/GeoUnit";
import PlaceCategories from "./pages/PlaceCategories";
import ContentCategories from "./pages/ContentCategories";
import Place from "./pages/Place";
import AddPlace from "./pages/AddPlace";
import TextEditor from "./pages/TextEditor";
import Content from "./pages/Content";
import AddContent from "./pages/AddContent";
import EditContent from "./pages/EditContent";
import EditPlace from "./pages/EditPlace";
import Linkestan from "./pages/Linkestan";
import EditLink from "./pages/EditLink";
import LinkComments from "./pages/LinkComments";
import AddLink from "./pages/AddLink";
import News from "./components/News/News";
import EditNews from "./pages/EditNews";
import AddNews from "./pages/AddNews";
import NewsComments from "./pages/NewsComments";
import Events from "./components/Events/Events";
import EventComments from "./pages/EventComments";
import AddEvent from "./pages/AddEvent";
import EditEvent from "./pages/EditEvent";
import Complaint from "./pages/Complaint";
import FeedBack from "./pages/FeedBack";
import AddFeedBack from "./pages/AddFeedBack";
import EditFeedBack from "./pages/EditFeedBack";
import Interaction from "./pages/Interaction";
import Notice from "./pages/Notice";
import TravelSuggestion from "./pages/TravelSuggestion";
import AddTravelSuggestion from "./pages/AddTravelSuggestion";
import EditTravelSuggestion from "./pages/EditTravelSuggestion";
import TravelSuggestionComments from "./pages/TravelSuggestionComments";
import PlaceComments from "./pages/PlaceComments";
import ContentComments from "./pages/ContentComments";
import Admin from "./pages/Admin";
import Gallery from "./pages/Gallery";
import AddGallery from "./pages/AddGallery";
import EditGallery from "./pages/EditGallery";
import Discounts from "./components/Discount/Discounts";
import AddDiscount from "./pages/AddDiscount";
import EditDiscount from "./pages/EditDiscount";
import Ads from "./pages/Ads";
import AddAdvertisement from "./pages/AddAdvertisement";
import EditAdvertisement from "./pages/EditAdvertisement"; 
import Users from './pages/Users';
import Analytics from "./pages/Analytics";

const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            staleTime: 0,
        },
    },
});

const App = () => {
    // const { setFpHash } = useContext(context);
    // useEffect(() => {
    //     const setFp = async () => {
    //         const fp = await FingerprintJS.load();
    //         const { visitorId } = await fp.get();
    //         setFpHash(visitorId);
    //     };
    //     setFp();
    // });
    return (
        <div className="App">
            <QueryClientProvider client={queryClient}>
                <BrowserRouter>
                    <ConfigProvider
                        locale={fa_IR}
                        theme={{
                            algorithm: theme.defaultAlgorithm,
                            token: {
                                colorPrimary: "#48D1CC",
                                fontFamily: "Vazir",
                                colorBgLayout: "white",
                            },
                        }}
                    >
                        <Routes>
                            <Route path="/sign-in" element={<SignIn />} />
                            <Route
                                index
                                element={<Navigate replace to="/geo" />}
                            />
                            <Route
                                path="/geo"
                                element={
                                    <ProtectedRoute>
                                        <Main>
                                            <GeoUnit />
                                        </Main>
                                    </ProtectedRoute>
                                }
                            />
                            <Route
                                path="/placeCategories"
                                element={
                                    <ProtectedRoute>
                                        <Main>
                                            <PlaceCategories />
                                        </Main>
                                    </ProtectedRoute>
                                }
                            />{" "}
                            <Route
                                path="/contentCategories"
                                element={
                                    <ProtectedRoute>
                                        <Main>
                                            <ContentCategories />
                                        </Main>
                                    </ProtectedRoute>
                                }
                            />
                            <Route
                                path="/place"
                                element={
                                    <ProtectedRoute>
                                        <Main>
                                            <Place />
                                        </Main>
                                    </ProtectedRoute>
                                }
                            />
                            <Route
                                path="/addPlace"
                                element={
                                    <ProtectedRoute>
                                        <Main>
                                            <AddPlace />
                                        </Main>
                                    </ProtectedRoute>
                                }
                            />
                            <Route
                                path="/addContent"
                                element={
                                    <ProtectedRoute>
                                        <Main>
                                            <AddContent />
                                        </Main>
                                    </ProtectedRoute>
                                }
                            />
                            <Route
                                path="/tiny"
                                element={
                                    <ProtectedRoute>
                                        <Main>
                                            <TextEditor />
                                        </Main>
                                    </ProtectedRoute>
                                }
                            />
                            <Route
                                path="/content"
                                element={
                                    <ProtectedRoute>
                                        <Main>
                                            <Content />
                                        </Main>
                                    </ProtectedRoute>
                                }
                            />{" "}
                            <Route
                                path="/editContent"
                                element={
                                    <ProtectedRoute>
                                        <Main>
                                            <EditContent />
                                        </Main>
                                    </ProtectedRoute>
                                }
                            />
                            <Route
                                path="/editPlace"
                                element={
                                    <ProtectedRoute>
                                        <Main>
                                            <EditPlace />
                                        </Main>
                                    </ProtectedRoute>
                                }
                            />
                            <Route
                                path="/linkestan"
                                element={
                                    <ProtectedRoute>
                                        <Main>
                                            <Linkestan />
                                        </Main>
                                    </ProtectedRoute>
                                }
                            />
                            <Route
                                path="/addLink"
                                element={
                                    <ProtectedRoute>
                                        <Main>
                                            <AddLink />
                                        </Main>
                                    </ProtectedRoute>
                                }
                            />
                            <Route
                                path="/editLink"
                                element={
                                    <ProtectedRoute>
                                        <Main>
                                            <EditLink />
                                        </Main>
                                    </ProtectedRoute>
                                }
                            />
                            <Route
                                path="/linkComments"
                                element={
                                    <ProtectedRoute>
                                        <Main>
                                            <LinkComments />
                                        </Main>
                                    </ProtectedRoute>
                                }
                            />
                            <Route
                                path="/news"
                                element={
                                    <ProtectedRoute>
                                        <Main>
                                            <News />
                                        </Main>
                                    </ProtectedRoute>
                                }
                            />
                            <Route
                                path="/editNews"
                                element={
                                    <ProtectedRoute>
                                        <Main>
                                            <EditNews />
                                        </Main>
                                    </ProtectedRoute>
                                }
                            />
                            <Route
                                path="/addNews"
                                element={
                                    <ProtectedRoute>
                                        <Main>
                                            <AddNews />
                                        </Main>
                                    </ProtectedRoute>
                                }
                            />
                            <Route
                                path="/newsComments"
                                element={
                                    <ProtectedRoute>
                                        <Main>
                                            <NewsComments />
                                        </Main>
                                    </ProtectedRoute>
                                }
                            />
                            <Route
                                path="/events"
                                element={
                                    <ProtectedRoute>
                                        <Main>
                                            <Events />
                                        </Main>
                                    </ProtectedRoute>
                                }
                            />
                            <Route
                                path="/eventComments"
                                element={
                                    <ProtectedRoute>
                                        <Main>
                                            <EventComments />
                                        </Main>
                                    </ProtectedRoute>
                                }
                            />
                            <Route
                                path="/addEvent"
                                element={
                                    <ProtectedRoute>
                                        <Main>
                                            <AddEvent />
                                        </Main>
                                    </ProtectedRoute>
                                }
                            />
                            <Route
                                path="/editEvent"
                                element={
                                    <ProtectedRoute>
                                        <Main>
                                            <EditEvent />
                                        </Main>
                                    </ProtectedRoute>
                                }
                            />
                            <Route
                                path="/complaints"
                                element={
                                    <ProtectedRoute>
                                        <Main>
                                            <Complaint />
                                        </Main>
                                    </ProtectedRoute>
                                }
                            />
                            <Route
                                path="/interactions"
                                element={
                                    <ProtectedRoute>
                                        <Main>
                                            <Interaction />
                                        </Main>
                                    </ProtectedRoute>
                                }
                            />
                            <Route
                                path="/notice"
                                element={
                                    <ProtectedRoute>
                                        <Main>
                                            <Notice />
                                        </Main>
                                    </ProtectedRoute>
                                }
                            />
                            <Route
                                path="/feedBack"
                                element={
                                    <ProtectedRoute>
                                        <Main>
                                            <FeedBack />
                                        </Main>
                                    </ProtectedRoute>
                                }
                            />
                            <Route
                                path="/addFeedBack"
                                element={
                                    <ProtectedRoute>
                                        <Main>
                                            <AddFeedBack />
                                        </Main>
                                    </ProtectedRoute>
                                }
                            />
                            <Route
                                path="/editFeedBack"
                                element={
                                    <ProtectedRoute>
                                        <Main>
                                            <EditFeedBack />
                                        </Main>
                                    </ProtectedRoute>
                                }
                            />
                            <Route
                                path="/travelSuggestion"
                                element={
                                    <ProtectedRoute>
                                        <Main>
                                            <TravelSuggestion />
                                        </Main>
                                    </ProtectedRoute>
                                }
                            />
                            <Route
                                path="/addTravelSuggestion"
                                element={
                                    <ProtectedRoute>
                                        <Main>
                                            <AddTravelSuggestion />
                                        </Main>
                                    </ProtectedRoute>
                                }
                            />
                            <Route
                                path="/editTravelSuggestion"
                                element={
                                    <ProtectedRoute>
                                        <Main>
                                            <EditTravelSuggestion />
                                        </Main>
                                    </ProtectedRoute>
                                }
                            />
                            <Route
                                path="/travelSuggestionComments"
                                element={
                                    <ProtectedRoute>
                                        <Main>
                                            <TravelSuggestionComments />
                                        </Main>
                                    </ProtectedRoute>
                                }
                            />
                            <Route
                                path="/placeComments"
                                element={
                                    <ProtectedRoute>
                                        <Main>
                                            <PlaceComments />
                                        </Main>
                                    </ProtectedRoute>
                                }
                            />
                            <Route
                                path="/contentComments"
                                element={
                                    <ProtectedRoute>
                                        <Main>
                                            <ContentComments />
                                        </Main>
                                    </ProtectedRoute>
                                }
                            />
                            <Route
                                path="/admin"
                                element={
                                    <ProtectedRoute>
                                        <Main>
                                            <Admin />
                                        </Main>
                                    </ProtectedRoute>
                                }
                            />
                            <Route
                                path="/discount"
                                element={
                                    <ProtectedRoute>
                                        <Main>
                                            <Discounts />
                                        </Main>
                                    </ProtectedRoute>
                                }
                            />
                            <Route
                                path="/addDiscount"
                                element={
                                    <ProtectedRoute>
                                        <Main>
                                            <AddDiscount />
                                        </Main>
                                    </ProtectedRoute>
                                }
                            />
                            <Route
                                path="/editDiscount"
                                element={
                                    <ProtectedRoute>
                                        <Main>
                                            <EditDiscount />
                                        </Main>
                                    </ProtectedRoute>
                                }
                            />
                            <Route
                                path="/gallery"
                                element={
                                    <ProtectedRoute>
                                        <Main>
                                            <Gallery />
                                        </Main>
                                    </ProtectedRoute>
                                }
                            />
                            <Route
                                path="/addGallery"
                                element={
                                    <ProtectedRoute>
                                        <Main>
                                            <AddGallery />
                                        </Main>
                                    </ProtectedRoute>
                                }
                            />
                            <Route
                                path="/editGallery"
                                element={
                                    <ProtectedRoute>
                                        <Main>
                                            <EditGallery />
                                        </Main>
                                    </ProtectedRoute>
                                }
                            />
                            <Route
                                path="/ads"
                                element={
                                    <ProtectedRoute>
                                        <Main>
                                            <Ads />
                                        </Main>
                                    </ProtectedRoute>
                                }
                            />
                            <Route
                                path="/addAdvertisement"
                                element={
                                    <ProtectedRoute>
                                        <Main>
                                            <AddAdvertisement />
                                        </Main>
                                    </ProtectedRoute>
                                }
                            />
                            <Route
                                path="/editAdvertisement"
                                element={
                                    <ProtectedRoute>
                                        <Main>
                                            <EditAdvertisement />
                                        </Main>
                                    </ProtectedRoute>
                                }
                            />
                            <Route 
                                path="/users"
                                element={
                                    <ProtectedRoute>
                                        <Main>
                                            <Users />
                                        </Main>
                                    </ProtectedRoute>
                                }
                            />
                              <Route
                                path="/analytics"
                                element={
                                    <ProtectedRoute>
                                        <Main>
                                            <Analytics />
                                        </Main>
                                    </ProtectedRoute>
                                }
                            />
                        </Routes>
                    </ConfigProvider>
                </BrowserRouter>
                <Toaster
                    position="top-center"
                    gutter={12}
                    containerStyle={{ margin: "8px" }}
                    toastOptions={{
                        success: {
                            duration: 3000,
                        },
                        error: {
                            duration: 5000,
                        },
                        style: {
                            fontSize: "16px",
                            maxWidth: "500px",
                            padding: "16px 24px",
                            backgroundColor: "var(--color-grey-0)",
                            color: "var(--color-grey-700)",
                        },
                    }}
                />
            </QueryClientProvider>
        </div>
    );
};

export default App;
